import { useGetConsultationsStatisticsQuery } from '@/core/services/statistics'

import ExamStatistic from '../components/ExamsStatistic'

export default function ExamStatisticContainer() {
  const { data } = useGetConsultationsStatisticsQuery()

  return <ExamStatistic total={data?.total ?? 0} />
}
